import { render, staticRenderFns } from "./LogReports.vue?vue&type=template&id=b43dff28&scoped=true"
import script from "./LogReports.vue?vue&type=script&lang=js"
export * from "./LogReports.vue?vue&type=script&lang=js"
import style0 from "./LogReports.vue?vue&type=style&index=0&id=b43dff28&prod&lang=scss&scoped=true"
import style1 from "./LogReports.vue?vue&type=style&index=1&id=b43dff28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43dff28",
  null
  
)

export default component.exports